"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalTime = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var qqsj_1 = require("../../../../modules/qqsj");
/**
 * 全球时间
 */
function GlobalTime(props) {
    var default_time = '-月-日 - - -';
    var _a = (0, react_1.useState)({
        beijing: default_time,
        london: default_time,
        newyork: default_time,
        sydney: default_time
    }), times = _a[0], setTime = _a[1];
    var getTime = function () {
        var time = qqsj_1.qqsj.getTime(setTime);
        if (time) {
            setTime(time);
        }
    };
    (0, react_1.useEffect)(function () {
        getTime();
        var cb = setInterval(function () {
            getTime();
        }, 1000);
        return function () {
            clearInterval(cb);
        };
    }, []);
    // 英股市场-伦敦时间
    if (props.type == 'london') {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "london_time", style: { marginTop: props.mt + "px" } },
                react_1.default.createElement("em", { className: "icon_ld" }),
                react_1.default.createElement("span", null,
                    "\u4F26\u6566\u65F6\u95F4\u00A0",
                    react_1.default.createElement("i", null, times.london)))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "global_time", style: { marginTop: props.mt + "px" } },
            react_1.default.createElement("span", { className: "tit" }, "\u5168\u7403\u65F6\u95F4"),
            react_1.default.createElement("div", { className: "t_item" },
                react_1.default.createElement("em", { className: "icon bj" }),
                react_1.default.createElement("span", null,
                    "\u5317\u4EAC",
                    react_1.default.createElement("i", null, times.beijing))),
            react_1.default.createElement("div", { className: "t_item" },
                react_1.default.createElement("em", { className: "icon ld" }),
                react_1.default.createElement("span", null,
                    "\u4F26\u6566",
                    react_1.default.createElement("i", null, times.london))),
            react_1.default.createElement("div", { className: "t_item" },
                react_1.default.createElement("em", { className: "icon ny" }),
                react_1.default.createElement("span", null,
                    "\u7EBD\u7EA6",
                    react_1.default.createElement("i", null, times.newyork))),
            react_1.default.createElement("div", { className: "t_item" },
                react_1.default.createElement("em", { className: "icon xn" }),
                react_1.default.createElement("span", null,
                    "\u6089\u5C3C",
                    react_1.default.createElement("i", null, times.sydney))))));
}
exports.GlobalTime = GlobalTime;
